<template>
  <van-nav-bar
    :title="title"
    :left-arrow="left"
    :fixed="fixed"
    :placeholder="placeholder"
    @click-left="onClickLeft"
  >
    <template v-if="right" #right>
      <router-link :to="right_link">{{right_text}}</router-link>
    </template>
  </van-nav-bar>
</template>
<script>
import Vue from "vue";
import { NavBar } from "vant";
Vue.use(NavBar);
export default {
  name: "Header",
  props: {
    back: {
      type: String,
      default: ""
    },
    left: {
      type: Boolean,
      default: true
    },
    right:{
      type: Boolean,
      default: false
    },
    right_text:{
      type: String,
      default: ""
    },
    right_link:{
      type: String,
      default: ""
    },
    fixed: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: Boolean,
      default: true
    },
    path: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: document.title
    };
  },
  methods: {
    onClickLeft() {
      // this.$store.state.app.routerBack = true;
      // let path = this.$store.state.app.routerList.pop();
      if (this.path) {
        this.$router.push({ path: this.path });
      } else if (this.back) {
        this.$router.go(-1);
        console.log('back');
      } else {
        // this.$router.push({ path: path });
        this.$router.go(-1);
      }
    }
  }
};
</script>
